<script setup>
    import { onMounted, ref, watch } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { useAuthStore } from '../../stores/useAuthStore'
    import { useUiStore } from '../../stores/useUiStore'
    import { useNotifStore } from '../../stores/useNotifStore'
    import { useCartStore } from '../../stores/useCartStore'

    import IconCart from '../components/icons/iconCart.vue'
    import IconBell from '../components/icons/iconBell.vue'
    import IconArrowLeft from '../components/icons/iconArrowLeft.vue'
    import IconScan from '../components/icons/iconScan.vue'
    import IconScanLine from '../components/icons/iconScanLine.vue'
    import IconUserCircle from '../components/icons/iconUserCircle.vue'
    import IconNote from '../components/icons/iconNote.vue'

    const route = useRoute()
    const router = useRouter()
    const authStore = useAuthStore()
    const { profile } = authStore
    const uiStore = useUiStore()
    const {title} = uiStore
    const notifStore = useNotifStore()
    const { notifications } = notifStore
    const cartStore = useCartStore()
    const { carts } = cartStore

    const search = ref()
    const searchTextHeader = ref()

    const goBarcodePage = () => {
        router.push({ name: "barcode"})
    }

    const goCartPage = () => {
        router.push({ name: "shopping.cart"})
    }

    const goNotifPage = () => {
        router.push({ name: "notification"})
    }

    const goActivityPage = () => {
        router.push({name:'activity'})
    }

    const goAccountPage = () => {
        router.push({name:'account'})
    }

    const goBack = () => {
        
        if (window.history.length > 1) {
            router.back()
        } else {
            router.push({ name: 'dashboard' })
        }
    }

    const submitSearch = () => {
        if(!search.value) return

        router.push({
            name: 'shopping',
            query: {
                q: search.value
            }
        })
    }

    const clearSearch = () => {
        search.value = ''

        router.push({
            name: 'shopping'
        })
    }

    watch(
        () => route.query.q,
        (val) => {
            search.value = val ?? ''
        },
        { immediate: true }
    )

    onMounted(()=>{
        search.value = route.query.q ?? ''
    })

</script>
<template>
    <header id="topbar" class="navbar navbar-expand-md navbar-navigation-menu" :class="['shopping', 'product.detail'].includes(route.name) ? 'topbar-white border-bottom' : ''">
        <div class="container-xl d-flex">
            <div class="navbar-brand navbar-brand-autodark d-none-navbar-horizontal text-white" role="button" v-if="route.name == 'dashboard'">
                <img src="/smp.png" alt="Sinar Michael Palembang" class="navbar-brand-image">&nbsp;<span class="name">Hi, {{ profile.name }}</span>
            </div>
            <div v-else-if="!['shopping', 'product.detail','dashboard'].includes(route.name)" class="p-2 header-prev text-white" @click="goBack" role="button">
                <IconArrowLeft size="20"/>{{ title }}
            </div>
            <div v-if="['shopping', 'product.detail'].includes(route.name)" class="p-2">
                <div class="d-flex align-items-center gap-2 position-relative">
                    <IconArrowLeft @click="goBack" size="20"/>
                    <div class="form-searching">
                        <input class="form-control" v-model="search" autocomplete="off" placeholder="Cari disini ..." @keyup.enter="submitSearch"/>

                        <span
                            v-if="search"
                            class="clear-search"
                            role="button"
                            @click="clearSearch"
                        >
                            ✕
                        </span>
                        
                        <IconScanLine size="20" />
                    </div>
                </div>
            </div>

            <div class="d-flex gap-3 align-items-center" v-if="!['notification','shopping.cart', 'shopping.detail','shopping.delivery','account.profile','account.address','account.hutang','account.setting','session.detail'].includes(route.name)">
                <div class="d-flex justify-content-center position-relative" role="button" @click="goCartPage">
                    <span class="position-absolute badge badge-notif top" v-if="carts.length">{{ carts.length }}</span>
                    <IconCart size="25" role="button"/>
                </div>
                <IconScan size="25" role="button" @click="goBarcodePage"/>
                <div class="d-flex justify-content-center position-relative" role="button" @click="goNotifPage">
                    <span class="position-absolute badge badge-notif top" v-if="notifications.length">{{ notifications.length }}</span>
                    <IconBell size="25" />
                </div>
                <IconNote size="25" role="button" @click="goActivityPage" class="d-none d-lg-block"/>
                <IconUserCircle size="25" role="button" @click="goAccountPage" class="d-none d-lg-block"/>
            </div>
        </div>
    </header>
</template>